import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Profile from "./components/profile"
import InvoiceSettings from "./components/invoice"
import OrderSettings from "./components/order_settings"
import Subscription from "./components/subcription"
import UserProfile from "./components/user_profile"
import ScanningIntegration from "./components/scanning_integration"

const TABS = [
    { id:"profile",      icon:"bx bx-building",  label:"Company Profile",      color:"#2563eb" },
    { id:"invoice",      icon:"bx bx-receipt",   label:"Invoice & Tax",        color:"#7c3aed" },
    { id:"orders",       icon:"bx bx-package",   label:"Order Settings",       color:"#059669" },
    { id:"scanning",     icon:"bx bx-radar",     label:"Scanning & Tracking",  color:"#0284c7" },
    { id:"subscription", icon:"bx bx-crown",     label:"Subscription",         color:"#d97706" },
];

const TAB_DESCS = {
    profile:      "Your lab's core identity and contact information",
    invoice:      "GST, bank details and invoice identity",
    orders:       "Order automation, TAT and workflow controls",
    scanning:     "Intraoral scan integrations, case tracking, and clinic appointments",
    subscription: "Your current plan and subscription validity",
};

const Companysettings = () => {
    const [activeTab, setActiveTab] = useState("profile");

    const auth = (() => { try { return JSON.parse(localStorage.getItem("authUser")) || {}; } catch (e) { return {}; } })();
    const roleStr = (auth?.role || auth?.user_role || "").toLowerCase();
    const isAdministrativeUser = ["admin", "superadmin", "owner", "master"].includes(roleStr);
    const isAdmin = ["admin", "superadmin", "owner"].includes(roleStr);

    const active = TABS.find(t => t.id === activeTab);

    if (!isAdministrativeUser) {
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags><title>My Profile | Settings</title></MetaTags>
                    <Container fluid>
                        <Breadcrumbs title="Settings" breadcrumbItem="My Profile" />
                        <div style={{ maxWidth:"860px" }}>
                            <div style={{ background:"#fff", borderRadius:"14px", border:"1px solid #e2e8f0", overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                                <div style={{ padding:"20px 28px", borderBottom:"1px solid #f1f5f9", display:"flex", alignItems:"center", gap:"14px" }}>
                                    <div style={{ width:"42px", height:"42px", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", background:"#eff6ff" }}>
                                        <i className="bx bx-user" style={{ fontSize:"20px", color:"#2563eb" }}></i>
                                    </div>
                                    <div>
                                        <div style={{ fontWeight:"800", fontSize:"16px", color:"#0f172a" }}>My Profile</div>
                                        <div style={{ fontSize:"12px", color:"#94a3b8", marginTop:"2px" }}>View and request changes to your personal information</div>
                                    </div>
                                </div>
                                <div style={{ padding:"28px" }}>
                                    <UserProfile auth={auth} isAdmin={false} />
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Company Settings | DG Dental Lab</title></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Settings" breadcrumbItem="Company" />
                    <div style={{ display:"flex", gap:"24px", alignItems:"flex-start" }}>

                        <div style={{ width:"240px", flexShrink:0 }}>
                            <div style={{ background:"#fff", borderRadius:"14px", border:"1px solid #e2e8f0", overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                                <div style={{ padding:"20px 20px 12px", borderBottom:"1px solid #f1f5f9" }}>
                                    <div style={{ fontWeight:"800", fontSize:"13px", color:"#0f172a", letterSpacing:"0.3px" }}>
                                        <i className="bx bx-cog me-2 text-primary"></i>Settings
                                    </div>
                                </div>
                                {TABS.map(tab => {
                                    const isActive = activeTab === tab.id;
                                    return (
                                        <div key={tab.id} onClick={() => setActiveTab(tab.id)}
                                            style={{ padding:"12px 20px", cursor:"pointer", display:"flex", alignItems:"center", gap:"12px", borderLeft: isActive ? `3px solid ${tab.color}` : "3px solid transparent", background: isActive ? `${tab.color}10` : "transparent", transition:"all 0.15s" }}>
                                            <div style={{ width:"34px", height:"34px", borderRadius:"8px", display:"flex", alignItems:"center", justifyContent:"center", background: isActive ? tab.color : "#f1f5f9", transition:"background 0.15s", flexShrink:0 }}>
                                                <i className={tab.icon} style={{ fontSize:"16px", color: isActive ? "#fff" : "#94a3b8" }}></i>
                                            </div>
                                            <span style={{ fontSize:"13px", fontWeight: isActive ? "700" : "500", color: isActive ? tab.color : "#64748b", transition:"color 0.15s" }}>{tab.label}</span>
                                        </div>
                                    );
                                })}
                                <div style={{ borderTop:"1px solid #f1f5f9", margin:"8px 0" }}></div>
                                <div onClick={() => setActiveTab("profile_requests")}
                                    style={{ padding:"12px 20px", cursor:"pointer", display:"flex", alignItems:"center", gap:"12px", borderLeft: activeTab === "profile_requests" ? "3px solid #e11d48" : "3px solid transparent", background: activeTab === "profile_requests" ? "#fff1f2" : "transparent", transition:"all 0.15s" }}>
                                    <div style={{ width:"34px", height:"34px", borderRadius:"8px", display:"flex", alignItems:"center", justifyContent:"center", background: activeTab === "profile_requests" ? "#e11d48" : "#f1f5f9", flexShrink:0 }}>
                                        <i className="fas fa-user-check" style={{ fontSize:"14px", color: activeTab === "profile_requests" ? "#fff" : "#94a3b8" }}></i>
                                    </div>
                                    <span style={{ fontSize:"13px", fontWeight: activeTab === "profile_requests" ? "700" : "500", color: activeTab === "profile_requests" ? "#e11d48" : "#64748b" }}>Profile Requests</span>
                                </div>
                            </div>
                            <div style={{ background:"linear-gradient(135deg, #1e293b 0%, #334155 100%)", borderRadius:"12px", padding:"18px", marginTop:"16px", color:"#fff" }}>
                                <div style={{ fontSize:"11px", color:"#94a3b8", fontWeight:"600", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"10px" }}>
                                    <i className="fas fa-info-circle me-1"></i> Quick Help
                                </div>
                                <p style={{ fontSize:"12px", color:"#cbd5e1", lineHeight:"1.6", margin:0 }}>
                                    Changes saved here affect how your lab appears on invoices, challans, and reports. Employee profile change requests need your approval.
                                </p>
                            </div>
                        </div>

                        <div style={{ flex:1, minWidth:0 }}>
                            <div style={{ background:"#fff", borderRadius:"14px", border:"1px solid #e2e8f0", overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                                <div style={{ padding:"20px 28px", borderBottom:"1px solid #f1f5f9", display:"flex", alignItems:"center", gap:"14px" }}>
                                    <div style={{ width:"42px", height:"42px", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", background: activeTab === "profile_requests" ? "#fff1f2" : `${active?.color}15` }}>
                                        <i className={activeTab === "profile_requests" ? "fas fa-user-check" : active?.icon} style={{ fontSize:"20px", color: activeTab === "profile_requests" ? "#e11d48" : active?.color }}></i>
                                    </div>
                                    <div>
                                        <div style={{ fontWeight:"800", fontSize:"16px", color:"#0f172a" }}>
                                            {activeTab === "profile_requests" ? "Employee Profile Update Requests" : active?.label}
                                        </div>
                                        <div style={{ fontSize:"12px", color:"#94a3b8", marginTop:"2px" }}>
                                            {activeTab === "profile_requests" ? "Review and approve employee profile change requests" : TAB_DESCS[activeTab]}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ padding:"28px" }}>
                                    {activeTab === "profile"          && <Profile />}
                                    {activeTab === "invoice"          && <InvoiceSettings />}
                                    {activeTab === "orders"           && <OrderSettings />}
                                    {activeTab === "scanning"         && <ScanningIntegration />}
                                    {activeTab === "subscription"     && <Subscription />}
                                    {activeTab === "profile_requests" && <UserProfile auth={auth} isAdmin={isAdmin} />}
                                </div>
                            </div>
                        </div>

                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Companysettings;
